import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 * @param processId
 * @param poId
 */
class ProcessServices {
    /**
     *
     * @param {*} payload
     * @return
     */
    createProcess = async (payload) => {
      const process = await Helpers.post({
        url: Constants.PROCESS,
        data: payload,
      });
      return process;
    }

    /**
     *
     * @param {*} payload
     * @return
     */
     updateProcess = async (payload) => {
       const process = await Helpers.put({
         url: Constants.PROCESS,
         data: payload,
       });
       return process;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
     updateProcessStatus = async (payload) => {
       const po = await Helpers.put({
         url: Constants.PROCESS_STATUS,
         data: payload,
       });
       return po;
     }

     /**
      *
      * @param {*} payload
      * @return
      */
        updateProcessWorkflowStep = async (payload) => {
          const process = await Helpers.post({
            url: Constants.PROCESS_WORKFLOW,
            data: payload,
          });
          return process;
        }

        /**
         * @param processId
         * @param {*} payload
         * @return
         */
      deleteProcess = async (payload) => {
        const process = await Helpers.delete({
          url: Constants.PROCESS,
          data: payload,
        });
        return process;
      }

      /**
       * @param {*} orgId
       * @return
       */
    getProcesses = async (orgId, page, limit, searchKeyword) => {
      let url = `${Constants.PROCESS}?`;
      if (orgId) url += `org_id=${orgId}&`;
      // if (status) url += `status=${status}&`;
      if (page) url += `page=${page}&`;
      if (limit) url += `limit=${limit}&`;
      if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

      const Processes = await Helpers.get({ url });

      return Processes;
    }
}
export default new ProcessServices();
